import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ContendingCampaignsTable from './ContendingCampaignsTable';
import './styles.scss';

/** Standalone page, kept so existing /contending-campaigns?key=... links still work. */
export default function ContendingCampaigns() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const impressionsKey = searchParams.get('key');

  useEffect(() => {
    if (!impressionsKey) {
      navigate('/inventory');
    }
  }, [impressionsKey]);

  return (
    <div className="contending-campaigns-container">
      <div className="contending-campaigns-header-heading">Contending Campaigns</div>
      {impressionsKey && (
        <ContendingCampaignsTable
          impressionsKey={impressionsKey}
          scrollHeight="calc(100vh - 14rem)"
        />
      )}
    </div>
  );
}
